import React from 'react';
import ReactDOM from 'react-dom';

import "babel-polyfill";

// General
import Root from "./modules/base/Root";
import Home from './modules/home/Home';

// Mail Log
import MailLogList from "./modules/mail_log/MailLogList";

// Users
import UserList from "./modules/user/UserList";
import UserListExternal from "./modules/user/UserListExternal";
import UserNew from "./modules/user/UserNew";
import UserEdit from "./modules/user/UserEdit";
import UserView from "./modules/user/UserView";
import UserProfile from "./modules/user/UserProfile";

// Tests
import Tests from "./modules/test/Tests";
import TestEdit from "./modules/test/TestEdit";
import TestNew from "./modules/test/TestNew";
import Test from "./modules/test/Test";

// Weaves
import Weaves from "./modules/weave/Weaves";
import WeaveNew from "./modules/weave/WeaveNew";
import WeaveEdit from "./modules/weave/WeaveEdit";

// Weave groups
import WeaveGroupList from "./modules/weave_group/WeaveGroupList";
import WeaveGroupNew from "./modules/weave_group/WeaveGroupNew";
import WeaveGroupEdit from "./modules/weave_group/WeaveGroupEdit";

// Forms
import Forms from "./modules/form/Forms";
import FormNew from "./modules/form/FormNew";
import FormEdit from "./modules/form/FormEdit";

// Branches
import BranchList from "./modules/branch/BranchList";
import BranchNew from "./modules/branch/BranchNew";
import BranchEdit from "./modules/branch/BranchEdit";

// Brands
import BrandList from "./modules/brand/BrandList";
import BrandNew from "./modules/brand/BrandNew";
import BrandEdit from "./modules/brand/BrandEdit";

// Notification
import NotificationList from "./modules/notification/NotificationList";

// Client
import ClientList from "./modules/client/ClientList";
import ClientEdit from "./modules/client/ClientEdit";
import ClientNew from "./modules/client/ClientNew";

// Statistic
import StatisticList from './modules/statistic/StatisticList';
import StatisticNew from './modules/statistic/StatisticNew';
import StatisticEdit from './modules/statistic/StatisticEdit';
import StatisticView from "./modules/statistic/StatisticView";

// TopBottom Statistics
import TopBottomList from "./modules/top_bottom/TopBottomList";

// Translations
import TranslationList from './modules/translation/TranslationList';
import TranslationEdit from './modules/translation/TranslationEdit';
import TranslationNew from './modules/translation/TranslationNew';

// Redux
import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from 'redux-devtools-extension';
import allReducers from "./redux";
import { Provider } from "react-redux";
import { Router, Route, IndexRoute, browserHistory } from 'react-router';
import thunk from "redux-thunk";



// General
import API from "./modules/base/API";
import { isLoggedIn, getUser } from "./modules/auth/Auth";
import Login from "./modules/auth/Login";
import PageNotFound from "./modules/base/PageNotFound";
import Translation from "./modules/base/Translation";
import UserAgreementPromnt from "./modules/user/UserAgreementPromt";
import Storage from "./modules/base/Storage";

const store = createStore(
    allReducers,
    composeWithDevTools(applyMiddleware(thunk))
    //applyMiddleware(thunk)
);

window.translator = new Translation();
window.translator.translations = [];

class App extends React.Component {

    constructor(props) {
        super(props);

        this.api = new API({
            get_groups_permissions: "/user/fetch/groups_permissions",
            set_last_active: "/user/set/active",
            get_version: "/version.php"
        });

        this.state = {
            permissions: [],
            activeMenus: [],
            version: null,
            translationsReady: false
        }
    }

    fetchAllowedComponents() {
        this.api.request({
            route: "get_groups_permissions",
            success: function (response) {
                this.setState({ permissions: response });
            }.bind(this)
        });

        if (window.location.href.indexOf("localhost") > -1) {
            this.setState({ version: "local" });
            return;
        }

        this.setState({ version: "1.0" });

        /*
        setInterval(() => {
            this.api.request({
                loader: false,
                local: true,
                route: "get_version",
                success: function (response) {
                    if (this.state.version !== null && this.state.version !== response) {
                        document.getElementById("newVersion").style.display = "block";
                    }
                    this.setState({ version: response });
                }.bind(this)
            });
        }, 2500);
        */
    }

    componentDidMount() {
        this.fetchAllowedComponents();

        if (isLoggedIn()) {
            window.translator.loadFromServer(() => {
                this.setState({ translationsReady: true });
            });
        }
    }

    render() {

        if (!isLoggedIn()) {
            return (
                <Login />
            )
        }

        if (this.state.permissions.length < 1 || !this.state.translationsReady) {
            return <div />;
        }

        if (getUser().role === 4 && [null, false].indexOf(Storage.get("skip_docs")) > -1) {
            const notAgreedDocuments = getUser().agreements.filter(item => item.agreed !== true);
            if (notAgreedDocuments.length > 0) {
                return <UserAgreementPromnt documents={notAgreedDocuments} />
            }
        }

        return (
            <Provider store={store}>
                <Router history={browserHistory}>
                    <Route component={Root}>
                        <Route path="/">
                            <IndexRoute component={Home} roles={this.state.permissions["Home"]} />
                        </Route>
                        <Route path="/tests">
                            <IndexRoute component={Tests} roles={this.state.permissions["Tests"]} />
                            <Route path="/tests/:testID" component={Test} roles={this.state.permissions["Test"]} />
                            <Route path="/tests/edit/:testID" component={TestEdit} roles={this.state.permissions["TestEdit"]} />
                            <Route path="/tests/add/new" component={TestNew} roles={this.state.permissions["TestNew"]} />
                        </Route>
                        <Route path="/weaves">
                            <IndexRoute component={Weaves} roles={this.state.permissions["Weaves"]} />
                            <Route path="/weaves/edit/:weaveID" component={WeaveEdit} roles={this.state.permissions["WeaveEdit"]} />
                            <Route path="/weaves/add/new" component={WeaveNew} roles={this.state.permissions["WeaveNew"]} />
                        </Route>
                        <Route path="/weave_groups">
                            <IndexRoute component={WeaveGroupList} roles={this.state.permissions["WeaveGroupList"]} />
                            <Route path="/weave_groups/edit/:weaveGroupID" component={WeaveGroupEdit} roles={this.state.permissions["WeaveGroupEdit"]} />
                            <Route path="/weave_groups/add/new" component={WeaveGroupNew} roles={this.state.permissions["WeaveGroupNew"]} />
                        </Route>
                        <Route path="/forms">
                            <IndexRoute component={Forms} roles={this.state.permissions["Forms"]} />
                            <Route path="/forms/edit/:formID" component={FormEdit} roles={this.state.permissions["FormEdit"]} />
                            <Route path="/forms/add/new" component={FormNew} roles={this.state.permissions["FormNew"]} />
                        </Route>
                        <Route path="/branches">
                            <IndexRoute component={BranchList} roles={this.state.permissions["BranchList"]} />
                            <Route path="/branches/add/new" component={BranchNew} roles={this.state.permissions["BranchNew"]} />
                            <Route path="/branches/edit/:branchID" component={BranchEdit} roles={this.state.permissions["BranchEdit"]} />
                        </Route>
                        <Route path="/brands">
                            <IndexRoute component={BrandList} roles={this.state.permissions["BrandList"]} />
                            <Route path="/brands/add/new" component={BrandNew} roles={this.state.permissions["BrandNew"]} />
                            <Route path="/brands/edit/:brandID" component={BrandEdit} roles={this.state.permissions["BrandEdit"]} />
                        </Route>
                        <Route path="/users">
                            <IndexRoute component={UserList} roles={this.state.permissions["UserList"]} />
                            <Route path="/users/external" component={UserListExternal} roles={this.state.permissions["UserList"]} />
                            <Route path="/users/add/new" component={UserNew} roles={this.state.permissions["UserNew"]} />
                            <Route path="/users/profile" component={UserProfile} roles={this.state.permissions["UserProfile"]} />
                            <Route path="/users/edit/:userID" component={UserEdit} roles={this.state.permissions["UserEdit"]} />
                            <Route path="/users/view/:userID" component={UserView} roles={this.state.permissions["UserView"]} />
                        </Route>
                        <Route path="/mysteryshoppers">
                            <IndexRoute component={UserListExternal} roles={this.state.permissions["UserList"]} />
                        </Route>
                        <Route path="/clients">
                            <IndexRoute component={ClientList} roles={this.state.permissions["ClientList"]} />
                            <Route path="/clients/add/:clientID" component={ClientNew} roles={this.state.permissions["ClientNew"]} />
                            <Route path="/clients/edit/:clientID" component={ClientEdit} roles={this.state.permissions["ClientEdit"]} />
                        </Route>
                        <Route path="/notification/list" component={NotificationList} roles={this.state.permissions["NotificationList"]} />
                        <Route path="/statistics">
                            <IndexRoute component={StatisticList} roles={this.state.permissions["StatisticList"]} />
                            <Route path="/statistics/add/new" component={StatisticNew} roles={this.state.permissions["StatisticNew"]} />
                            <Route path="/statistics/edit/:statisticID" component={StatisticEdit} roles={this.state.permissions["StatisticEdit"]} />
                            <Route path="/statistics/view/:statisticID" component={StatisticView} roles={this.state.permissions["StatisticView"]} />
                        </Route>
                        <Route path="/top_bottom">
                            <IndexRoute component={TopBottomList} roles={this.state.permissions["TopBottom10"]} />
                        </Route>
                        <Route path="/mail_log">
                            <IndexRoute component={MailLogList} roles={this.state.permissions["MailLogList"]} />
                        </Route>
                        <Route path="/translations">
                            <IndexRoute component={TranslationList} roles={this.state.permissions["TranslationList"]} />
                            <Route path="/translations/add/new" component={TranslationNew} roles={this.state.permissions["TranslationNew"]} />
                            <Route path="/translations/edit/:translationID" component={TranslationEdit} roles={this.state.permissions["TranslationEdit"]} />
                        </Route>
                        <Route path='*' component={PageNotFound} />
                    </Route>
                </Router>
            </Provider>
        )
    }
}

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js